module.exports = __webpack_public_path__ + "static/hero-brewery2-c217761a7485d6be8752714d414692ee.png";